import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  fetchDiseases,
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchDiseases.STARTED]: handleActionStart,
  [fetchDiseases.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload.data.diseases;
  },
  [fetchDiseases.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.diseases,
  [clearCurrentPatient]: () => initialState,
});
